import React from "react";
import { createRoot } from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store.js";
import App from "./App.js";

import "./index.scss";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import * as Sentry from "@sentry/react";
import "./i18n.js";
const { REACT_APP_SENTRY_DSN, REACT_APP_ENV } = process.env;

const container = document.getElementById("root");
const root = createRoot(container);
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN, // set in .env for prod builds
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({ levels: ["log", "warn", "error"] }),
    ],
    tracesSampleRate: 0.05, // lower sample rate in prod
    environment: "production",
    enableLogs: true,
  });
} else {
  console.info("Sentry disabled in development/test environment");
}
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
       
          <App />
       
      </LocalizationProvider>
    </PersistGate>
  </Provider>
);
